import actionCreatorFactory from "typescript-fsa";
import { PaymentUrlRequestBody } from "../../core/api/requests/payment/url/types";
import { CommonAsyncType } from "../../core/types";

const actionCreator = actionCreatorFactory("@@Payment");

export const paymentActions = {
  getPaymentUrl: actionCreator.async<CommonAsyncType<{ url: string }> & PaymentUrlRequestBody, {}>("GET_PAYMENT_URL"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
